module.exports = __webpack_public_path__ + "img/yema-big.0b9ed3f4.jpg";